import React from 'react';
import { clsx } from 'clsx';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'default' | 'error' | 'warning' | 'success';
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = 'medium', color = 'default', className, children, ...props }, ref) => {
    const classes = clsx(
      'inline-flex items-center justify-center rounded-full transition-all',
      'focus:outline-none focus:ring-2 focus:ring-offset-2',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      {
        // Size variants
        'w-8 h-8 text-sm': size === 'small',
        'w-10 h-10 text-base': size === 'medium',
        'w-12 h-12 text-lg': size === 'large',

        // Color variants
        'text-gray-600 hover:bg-gray-100 focus:ring-gray-500': color === 'default',
        'text-primary hover:bg-primary-50 focus:ring-primary-500': color === 'primary',
        'text-secondary hover:bg-secondary-50 focus:ring-secondary-500': color === 'secondary',
        'text-error hover:bg-error-50 focus:ring-error-500': color === 'error',
        'text-warning hover:bg-warning-50 focus:ring-warning-500': color === 'warning',
        'text-success hover:bg-success-50 focus:ring-success-500': color === 'success',
      },
      className
    );

    return (
      <button ref={ref} type="button" className={classes} {...props}>
        {children}
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;

